import Help from '../Help';

export default {
  path: ':nodeId',

  getComponents(location, cb) {
    cb(null, Help);
  },
};
